(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/player-constants.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/player-constants.js'); 
'use strict';

const extraButtonActions = {
  HIDE_EXTRA_BUTTON_ON_FULLSCREEN: 'hideExtraButtonOnFullScreen'
};
const controlBar = {
  children: ['empLiveDisplay', 'volumePanel', 'progressControl', 'fullscreenToggle']
};
const constants = {
  extraButtonActions,
  controlBar
};
svs.components.emp_video_player.helpers.constants = constants;
 })(window);